/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Přehled',
        type : 'basic',
        icon : 'heroicons_outline:home',
        link : '/dashboard'
    },
    {
        id   : 'users',
        title: 'Správa uživatelů',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/users'
    },
    {
        id   : 'products',
        title: 'Správa produktů',
        type : 'basic',
        icon : 'heroicons_outline:collection',
        link : '/products'
    },
    {
        id   : 'balloons',
        title: 'Správa balónů',
        type : 'basic',
        icon : 'heroicons_outline:location-marker',
        link : '/balloons'
    },
    {
        id   : 'places',
        title: 'Správa míst',
        type : 'basic',
        icon : 'heroicons_outline:office-building',
        link : '/places'
    },
    {
        id   : 'shipments',
        title: 'Správa dopravy',
        type : 'basic',
        icon : 'heroicons_outline:truck',
        link : '/shipments'
    },
    {
        id   : 'orders',
        title: 'Správa objednávek',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-list',
        link : '/orders'
    },
    {
        id   : 'shipments',
        title: 'Správa rezervací',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-check',
        link : '/order-reservations'
    },
    {
        id   : 'payments',
        title: 'Správa plateb',
        type : 'basic',
        icon : 'heroicons_outline:credit-card',
        link : '/payments'
    },
    {
        id   : 'coupons',
        title: 'Správa kupónů',
        type : 'basic',
        icon : 'heroicons_outline:ticket',
        link : '/coupons'
    },
    {
        id   : 'terms',
        title: 'Správa letů',
        type : 'basic',
        icon : 'heroicons_outline:collection',
        link : '/terms'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
